const TreeNode = require('../TreeNode');
const Q_most_single_target_damage = require('./Q_most_single_target_damage');
const Q_slash_or_bash = require('./Q_slash_or_bash');
const BattleCalc = require('../../BattleCalc');
const AICalc = require('../AICalc');
const UseAbility = require('../UseAbility');
const MortalStrike = require('../../abilities/melee_combat/MortalStrike');

const Q_state_of_best_target = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  // branch indexes
  const LOW_HP_LOW_ARMOR = 0;
  const HIGH_HP_LOW_ARMOR = 1;
  const HIGH_ARMOR = 2;
  const MORTAL_STRIKE = 3;

  node.armorBreak = BattleCalc.getEquippedAbility(actor, 'armor_break');
  node.burningHands = BattleCalc.getEquippedAbility(actor, 'burning_hands');
  node.meleeAttack = BattleCalc.getEquippedAbility(actor, 'melee_attack');
  node.mortalStrike = BattleCalc.getEquippedAbility(actor, 'mortal_strike');

  node.branches[LOW_HP_LOW_ARMOR] = new Q_most_single_target_damage(actor, battleState);

  if (node.mortalStrike) {
    node.branches[MORTAL_STRIKE] = new UseAbility(actor, 'mortal_strike');
  } else {
    node.branches[MORTAL_STRIKE] = node.branches[LOW_HP_LOW_ARMOR];
  }

  // we will pass this a reference to our single-target-damage node, in case the necessary abilities are not equipped
  node.branches[HIGH_HP_LOW_ARMOR] = new Q_slash_or_bash(
    actor,
    battleState,
    node.branches[LOW_HP_LOW_ARMOR]
  );

  if (node.armorBreak) {
    node.branches[HIGH_ARMOR] = new UseAbility(actor, 'armor_break');
  } else {
    node.branches[HIGH_ARMOR] = node.branches[HIGH_HP_LOW_ARMOR];
  }

  node.mortalStrikeWillKill = (target) => {
    if (!node.mortalStrike) return false;

    if (!BattleCalc.getCondition(target, 'slowed') && !BattleCalc.getCondition(target, 'stunned'))
      return false;

    const dummy_target = JSON.parse(JSON.stringify(target));
    node.dummy_mortal_strike_ability.execute(actor, dummy_target, true);
    return dummy_target.hp <= 0;
  };
  node.dummy_mortal_strike_ability = new MortalStrike(battleState);

  node.query = function (static_target) {
    const calculateTopSingleTargetDamage = () => {
      let burningHandsDamage = this.burningHands ? this.burningHands.damage : 0;
      return (
        Math.max(this.meleeAttack.damage, burningHandsDamage) *
        BattleCalc.getDamageModFromAffinities(actor, _bestTarget)
      );
    };

    const lowHP_lowArmor = () => {
      const dot_potency = BattleCalc.getCombinedDoTPotency(_bestTarget);
      return (
        dot_potency > _bestTargetHP * 0.333 ||
        (_bestTargetHP < _topSingleTargetDamage * 2.5 && _bestTargetArmor < 30)
      );
    };

    const highHP_lowArmor = () => {
      const dot_potency = BattleCalc.getCombinedDoTPotency(_bestTarget);
      return (
        dot_potency <= _bestTargetHP * 0.333 &&
        _bestTargetHP > _topSingleTargetDamage * 2.5 &&
        _bestTargetArmor < 30
      );
    };

    let _bestTarget = static_target || AICalc.getBestMeleeTarget(actor, battleState);
    if (!_bestTarget) return null;
    let _bestTargetHP = _bestTarget.hp;
    let _bestTargetArmor =
      _bestTarget.attributes.armorClass -
      (BattleCalc.getCondition(_bestTarget, 'armor_broken')?.potency ?? 0);

    let _topSingleTargetDamage = calculateTopSingleTargetDamage();

    if (node.mortalStrikeWillKill(_bestTarget)) {
      return this.branches[MORTAL_STRIKE].query(_bestTarget);
    } else if (lowHP_lowArmor()) {
      return this.branches[LOW_HP_LOW_ARMOR].query(_bestTarget);
    } else if (highHP_lowArmor()) {
      return this.branches[HIGH_HP_LOW_ARMOR].query(_bestTarget);
    } else if (node.armorBreak) {
      return this.branches[HIGH_ARMOR].query(_bestTarget);
    } else {
      return this.branches[HIGH_HP_LOW_ARMOR].query(_bestTarget);
    }
  };

  return node;
};
module.exports = Q_state_of_best_target;
